import { FC } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BatteryRow } from './BatteryRow';
import { BatteryStatusSummary } from './BatteryStatusSummary';
import { Package, Plus } from 'lucide-react';
import type { Battery } from '@/hooks/useBatteryContainers';

interface StockSectionProps {
  batteries: Battery[];
  allocations?: Map<string, string>;
  onAllocate?: (battery: Battery) => void;
  onEdit?: (battery: Battery) => void;
  onDelete?: (battery: Battery) => void;
  onAddStock?: () => void;
}

export const StockSection: FC<StockSectionProps> = ({
  batteries,
  allocations,
  onAllocate,
  onEdit,
  onDelete,
  onAddStock
}) => {
  // Filter batteries with status 'vrij'
  const stockBatteries = batteries.filter(b => b.status === 'vrij');

  return (
    <Card className="h-full flex flex-col border-l-4 border-l-green-500">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2 text-green-700 dark:text-green-400">
            <Package className="h-5 w-5" />
            Voorraad
          </CardTitle>
          {onAddStock && (
            <Button size="sm" onClick={onAddStock}>
              <Plus className="h-4 w-4 mr-1" />
              Batterij
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent className="flex-1 overflow-auto space-y-6">
        <BatteryRow
          batteries={stockBatteries}
          powerKw={50}
          allocations={allocations}
          onAllocate={onAllocate}
          onEdit={onEdit}
          onDelete={onDelete}
        />
        <BatteryRow
          batteries={stockBatteries}
          powerKw={100}
          allocations={allocations}
          onAllocate={onAllocate}
          onEdit={onEdit}
          onDelete={onDelete}
        />
        {stockBatteries.length === 0 && (
          <div className="text-center py-8 text-muted-foreground">
            Geen batterijen op voorraad
          </div>
        )}
        <BatteryStatusSummary batteries={stockBatteries} allocations={allocations} />
      </CardContent>
    </Card>
  );
};
